module.exports = __webpack_public_path__ + "img/07_2.a1e813e8.png";